// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"ti_a big_b big_bj","HomeBaseBanner__hint":"ti_b big_vh","HomeBaseBanner__link":"ti_c"};